import {
    UPDATE_FILE_REFERENCE_REQUEST,
    updateFileReferenceSuccess,
    updateFileReferenceFailure,
    showSuccessNotification
} from 'Redux/Action';
import { ofType } from 'redux-observable';
import { from } from 'rxjs';
import { mergeMap, catchError } from 'rxjs/operators';
import { TEpic } from "Redux/Config";

export const updateFileReferenceEpic: TEpic = (action$, store$, { FileReferenceRepository }) => {
    return action$.pipe(
        ofType(UPDATE_FILE_REFERENCE_REQUEST),
        mergeMap(action => from(FileReferenceRepository.update( action.payload.id, action.payload.updateData ))
            .pipe(
                mergeMap((fileReference) => {
                    return from([
                        showSuccessNotification(`Die Speicherung der Datei war erfolgreich.`),
                        updateFileReferenceSuccess(fileReference),
                    ]);
                }),
                catchError( error => {
                    return from([
                        updateFileReferenceFailure(error)
                    ])
                })
            )
        ),
    );
}
